/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Link from "next/link";
import Swal from "sweetalert2";

// CAPTCHA
import ReCAPTCHA from "react-google-recaptcha";
const ReCaptchaComponent = ReCAPTCHA as unknown as React.ComponentType<any>;
import axios from "axios";
import { styled } from "@mui/material/styles";
import { FormControlLabel } from "@mui/material";
// CAPTCHA

import SendIcon from "@mui/icons-material/Send";

declare global {
  interface Window {
    gtag: (
      event: string,
      action: string,
      params: { [key: string]: any },
    ) => void;
  }
}

function contactus({ ip }: any) {
  useEffect(() => {
    // เรียกใช้งาน gtag สำหรับ Conversion Tracking
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-11490672773/hkBVCKDAiPYZEIWBl-cq",
        value: 1.0,
        currency: "THB",
      });
    }
  }, []);

  const img: any = "/static/images/s-contact.png";

  // Captcha
  const CenteredFormControlLabel = styled(FormControlLabel)({
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "10px",
  });
  const [value, setValue] = React.useState<string | null>(null);
  const captchaRef: any = React.useRef(null);
  const handleRecaptchaChange = React.useCallback(
    (token: string | null) => {
      setValue(token); // Update recaptchaToken in the form
    },
    [setValue],
  );
  // Captcha

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  const [firstName, setFirstName] = useState<any>("");
  const [lastName, setLastName] = useState<any>("");
  const [company, setCompany] = useState<any>("");
  const [email, setEmail] = useState<any>("");
  const [message, setMessage] = useState<any>("");
  const [privacy, setPrivacy] = useState<Boolean>(false);

  const validateEmail = (email: String) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  };

  const handleSubmit = async () => {
    const array = [firstName, lastName, company, email, message];
    let checkEmpty = false;
    array.map((value: any, key: any) => {
      if (value == "") {
        checkEmpty = true;
      }
    });
    if (!checkEmpty) {
      const emailValidate = validateEmail(email);
      if (!emailValidate) {
        Swal.fire("Error!", "Please check your email", "error");
        return;
      } else {
        // CAPTCHA
        if (!value) {
          Swal.fire("Error!", "Please verify reCAPTCHA.", "error");
          return;
        }
        const cfResponse = await axios.post("/api/google", {
          token: value,
          ip: ip,
        });
        captchaRef.current?.reset();
        setValue(null);
        // CAPTCHA
        if (!cfResponse.data.status.success) {
          Swal.fire("Error!", "Please verify reCAPTCHA.", "error");
          return false;
        } else {
          const url = process.env.NEXT_PUBLIC_BASE_URL_API;
          const response = await axios.post(`${url}/contact/save`, {
            firstName: firstName,
            lastName: lastName,
            company: company,
            email: email,
            message: message,
          });
          if (response.data.status == "success") {
            Swal.fire(
              "Successful!",
              "Your information was sent to ITP ASIA Co., Ltd.",
              "success",
            ).then(function () {
              location.reload();
            });
          } else {
            Swal.fire("Error!", "", "error");
          }
        }
      }
    } else {
      Swal.fire("Error!", "Please fill your information", "error");
    }
  };
  return (
    <>
      <div className="wrapper">
        <Header />
        <section className="key_visual">
          <motion.img
            // animate={imgAnimation}
            // onMouseMove={(e) => handleMouseMove(e)}
            src={img}
            alt="Event Activation"
            loading="lazy"
          />
          <div className="img-bg" />
        </section>

        <section className="sv_content black-content">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center heading-contact mb-5">
                <h2 className="lh-1 mb-0 t-white">
                  Interested in our service?
                </h2>
                <h1 className="mb-3 t-green">Let’s get in touch!</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6 contact-text t-white">
                <h1 className="fw-bolder mb-4">
                  ITP Asia Co., Ltd. (Head Office)
                </h1>
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="1em"
                          viewBox="0 0 384 512"
                        >
                          <path d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z" />
                        </svg>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p>
                          589/160 Central City Tower, Room OF3004, 30th Floor,
                          <br />
                          Debaratana Road, Bangna Nuea, Bangna,
                          <br />
                          Bangkok 10260
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="1em"
                          viewBox="0 0 512 512"
                        >
                          <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                        </svg>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <p>
                          <span className="fw-bold">TEL: </span>+66 (0)
                          2-745-6050
                          <br />
                          <span className="fw-bold">JPN:</span>Mr. Yoshikazu
                          Koyama +66(0)2-745-6050-4 #701
                          <br />
                          <span className="fw-bold">TH: </span>K. Nitinunt (Cat)
                          +66(0)2-745-6050-4 #304
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-3">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="1em"
                          viewBox="0 0 512 512"
                        >
                          <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                        </svg>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <Link href="mailto:info@itp.co.th">INFO@ITP.CO.TH</Link>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.8212533856795!2d100.63141907514009!3d13.668630499213572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d5ff098c5c339%3A0xab290c8767e933fa!2sITP%20ASIA%20CO.%2CLTD.%20(%20IT%20%2F%20AI%20%2F%20Marketing%20%2F%20Translation%20%2F%20Printing%20%2F%20Event%20)!5e0!3m2!1sth!2sth!4v1698520609914!5m2!1sth!2sth"
                  width="100%"
                  height="450"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <section className="sv_content gray-content">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center text-center Me0-heading-spr">
                <h1 className="lh-1 t-green fw-bolder mb-0">
                  Or just drop your information here
                </h1>
                <h2 className="mb-3">and we will contact back so soon!</h2>
              </div>
            </div>
            <div className="row">
              <form className="row g-4">
                <div className="col-12 col-md-6 mt-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="First name"
                    onChange={(e: any) => {
                      setFirstName(e.target.value);
                    }}
                    value={firstName}
                  />
                </div>
                <div className="col-12 col-md-6 mt-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Last name"
                    onChange={(e: any) => {
                      setLastName(e.target.value);
                    }}
                    value={lastName}
                  />
                </div>
                <div className="col-12 col-md-6 mt-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Company"
                    onChange={(e: any) => {
                      setCompany(e.target.value);
                    }}
                    value={company}
                  />
                </div>
                <div className="col-12 col-md-6 mt-3">
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    placeholder="Email"
                    onChange={(e: any) => {
                      setEmail(e.target.value);
                    }}
                    value={email}
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Message"
                      rows={8}
                      id="message"
                      onChange={(e: any) => {
                        setMessage(e.target.value);
                      }}
                      value={message}
                    ></textarea>
                    <label className="textareaplaceholder" htmlFor={"message"}>
                      Message
                    </label>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* CAPTCHA */}
                  <ReCaptchaComponent
                    sitekey={`${process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY}`}
                    onChange={handleRecaptchaChange}
                    ref={captchaRef}
                  />
                  {/* CAPTCHA */}
                </div>
                <div className="col-12 check-form_contact">
                  <div className="form-check d-flex justify-content-center align-items-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkcontact"
                      onClick={(e: any) => {
                        setPrivacy(!privacy);
                      }}
                    />
                    <label className="form-check-label" htmlFor="checkcontact">
                      I agree with{" "}
                      <Link href="/privacypolicy" target="_blank">
                        Privacy Policy
                      </Link>{" "}
                      and{" "}
                      <Link href="/termsandconditions" target="_blank">
                        Terms and Condition
                      </Link>
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 text-center py-3">
                    <div className="d-flex justify-content-center align-items-center">
                      <Link
                        className="link link-inner grow_skew_forward"
                        href="#"
                        onClick={(e: any) => {
                          e.preventDefault();
                          if (privacy == true) {
                            handleSubmit();
                          } else {
                            Swal.fire(
                              "Fail !",
                              "Please check Privacy Policy and Terms and Condition",
                              "error",
                            ).then(function () {
                              return false;
                            });
                          }
                        }}
                      >
                        Submit{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="1em"
                          viewBox="0 0 512 512"
                        >
                          <path d="M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}
export async function getServerSideProps(context: any) {
  const forwarded = context.req.headers["x-forwarded-for"];
  const ip = forwarded
    ? forwarded.split(/, /)[0]
    : context.req.connection.remoteAddress;
  return {
    props: {
      ip: ip,
    },
  };
}
export default contactus;
